import StaticPageRedirect from '../component/StaticPageRedirect';
export default function Home() { return <StaticPageRedirect page="home" />; }
